import {
  mdiAccountSupervisorCircle,
  mdiMailboxOutline,
  mdiPencilRuler,
  mdiPrinter,
  mdiSitemapOutline,
  mdiWeb,
} from '@mdi/js'

export const DEFAULT_LOCALE = 'en-NZ'
export const DEFAULT_CURRENCY = 'NZD'

export const GST_RATE = 0.15

export const PRICING_INTERVAL = {
  MONTH: 'month',
  WEEK: 'week',
}

export const JOB_NAME_CHAR_LIMIT = 80 // Number of characters
export const CAMPAIGN_NAME_CHAR_LIMIT = 50 // Number of characters

export const QUOTE_STATUS = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING', // Pending customer action
  CHANGE_REQUESTED: 'CHANGE_REQUESTED', // Customer requested changes
  PAYMENT_REQUIRED: 'PAYMENT_REQUIRED', // Customer confirmed job but has not paid
  CONFIRMED: 'CONFIRMED', // Job confirmed and paid
}

export const AVAILABLE_PRODUCTS = {
  DESIGN: {
    type: 'Design',
    icon: mdiPencilRuler,
    billingLine: 'design',
    projectKey: 'DESIGN',
    hasCalculator: true,
  },
  DIGITAL: {
    type: 'Digital',
    icon: mdiSitemapOutline,
    projectKey: 'DIGITAL',
    hasCalculator: true,
  },
  LETTERBOX: {
    type: 'Letterbox',
    icon: mdiMailboxOutline,
    projectKey: 'LETTER',
  },
  PRINT: {
    type: 'Print',
    icon: mdiPrinter,
    billingLine: 'print',
    projectKey: 'PRINT',
    hasCalculator: true,
  },
  // SOCMED: {
  //   type: 'Social Media',
  //   icon: mdiAccountSupervisorCircle
  // },
  // WEBSITE: {
  //   type: 'Website',
  //   icon: mdiWeb
  // }
}

export const DEFAULT_QUOTE_DATA = {
  id: '',
  name: '',
  briefId: null,
  isActive: true,
  integration: {
    liberty: {},
  },
  products: [],
  status: QUOTE_STATUS.DRAFT,
}
